<script lang="ts">
  import { onDestroy, onMount } from 'svelte'
  import { db } from '$lib/storage'
  import * as settingsStore from '$lib/storage/settings'
  import { applyThemeSync } from '$lib/theme'
  import { currentRoute, navigate } from '$lib/router'
  import { CityList } from './features/city-list'
  import { CityEditor } from './features/city-editor'
  import { HelpModal, openHelp } from './features/help'
  import { ImportDialog, openImportDialog } from './features/import'

  let booted = $state(false)

  onMount(async () => {
    await db.open()
    // Install the saved theme before any feature mounts. CSS retints panels
    // automatically; the Pixi scene reads bg-base on init so the saved
    // theme is in effect by the time CityEditor / CityView creates the
    // renderer.
    const settings = await settingsStore.get()
    applyThemeSync(settings.theme)
    // Resume the last opened plan when the user lands on `/`.
    if (
      settings.lastOpenedPlanId !== undefined &&
      ($currentRoute.name === 'list' || $currentRoute.name === 'unknown')
    ) {
      navigate({ name: 'city', planId: settings.lastOpenedPlanId })
    }
    booted = true
    window.addEventListener('keydown', onGlobalKeyDown)
  })

  onDestroy(() => {
    window.removeEventListener('keydown', onGlobalKeyDown)
  })

  /** Global "?" listener for the help modal. Skipped when focus is in a
   *  text input so the player can type "?" inside the search box without
   *  flipping the modal. Honours both "?" directly and Shift+/ (which is
   *  what produces "?" on US keyboards) — keyboard layouts that emit "?"
   *  via a different combo just need the key to be the literal "?". */
  function onGlobalKeyDown(ev: KeyboardEvent) {
    if (ev.key !== '?') return
    const t = ev.target as HTMLElement | null
    if (t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.isContentEditable)) return
    if (ev.ctrlKey || ev.metaKey || ev.altKey) return
    ev.preventDefault()
    openHelp()
  }

  function openDialog(file: File | null = null) {
    openImportDialog(file)
  }
</script>

{#if !booted}
  <main class="flex min-h-screen items-center justify-center bg-bg-base text-text-secondary">
    <p>Loading…</p>
  </main>
{:else if $currentRoute.name === 'city'}
  <CityEditor planId={$currentRoute.planId} />
{:else}
  <CityList onImport={() => openDialog()} onFileDrop={(f) => openDialog(f)} />
{/if}

<ImportDialog />
<HelpModal />
